export enum RoleType {
  "ADMIN" =  "Adminisztrátor",
  "GONDNOKNO" ="Gondnoknő",
  "MUSZAKOS" = "Műszakos",
  "MUSZAKI_VEZETO" = "Műszaki vezető",
  "TAKARITO" = "Takarító",
  "RECEPCIOS" = "Recepciós"
  
}